export const iconFontAwesomeScienceVialVirus = (
	<i className="fa-solid fa-vial-virus"></i>
);
